import * as types from './mutations-type'

const mutations = {
    [types.HASNEXT](state, payload) {
        state.hasnext = payload
    },
    [types.TOTALEMAILS](state, payload) {
        state.requestPayload.totemails = payload
    },
    [types.TOTALSPACEYEMAILS](state, payload) {
        state.requestPayload.totspaceyemails = payload
    },
    [types.LASTPAGE](state, payload) {
        state.lastpage = payload
    },
    [types.REQUEST_PAYLOAD](state, payload) {
        state.requestPayload = payload
    },
    [types.RESPONSE_PAYLOAD](state, payload) {
        state.responsePayload = payload
    },
    [types.PERPAGE](state, payload) {
        state.requestPayload.perpage = payload
    },
    [types.SETPAGE](state, payload) {
        state.requestPayload.page = payload
    },
    [types.SORTING_FIELD](state, payload) {
        state.requestPayload.sorting_field = payload
    },
    [types.SORTING_DIRECTION](state, payload) {
        state.requestPayload.sorting_direction = payload
    },
    [types.STARTTIME](state, payload) {
        state.start_time = payload
    },
    [types.ENDTIME](state, payload) {
        state.end_time = payload
    },
    [types.ISFROMSEARCH](state, payload) {
        state.isfromsearch = payload
    },
    [types.ISLOADING](state, payload) {
        state.isloading = payload
    },

    [types.UPDATESTATUS](state, payload) {
        state.responsePayload.forEach(function(o) {
            if (o.muid === payload.muid) {
                o.deleted = payload.deleted
            }
        })
    },
    [types.UPDATEFLAG](state, payload) {
        state.responsePayload.forEach(function(o) {
            if (o.muid === payload.muid) {
                o.panelist_core = payload.panelist_core
            }
        })
    },
    [types.UPDATEPOINTS](state, payload) {
        state.responsePayload.forEach(function(o) {
            if (o.muid === payload.muid) {
                o.panelist_score = payload.panelist_score
            }
        })
    },
    [types.UPDATEMARK](state, payload) {
        state.responsePayload.forEach(function(o) {
            if (o.muid === payload.muid) {
                o.email_read = payload.email_read
            }
        })
    },
    [types.UPDATESCORE](state, payload) {
        state.responsePayload.forEach(function(o) {
            if (o.muid === payload.muid) {
                o.panelist_score = payload.score
            }
        })
    },
    [types.PAGING](state, payload) {
        state.paging = payload
    },
    [types.CURRENT_PAGE_EMAIL_FROM_EMAIL_DATE](state, payload) {
        if(state.paging !== '' && state.paging.length){
          state.paging.forEach(function(o) {
              if (o.page_number === payload.page) {
                state.requestPayload.current_page_email_from_date = o.page_start_email_date
              }
          })
        }else{
          state.requestPayload.current_page_email_from_date = ''
        }
    },
    [types.CURRENT_PAGE_EMAIL_FROM_MUID](state, payload) {
        if (state.paging !== '' && state.paging.length) {
            state.paging.forEach(function (o) {
                if (o.page_number === payload.page) {
                    let f1 = o.page_start_muid,
                        f2 = o.page_start_field
                    state.requestPayload.current_page_email_from_muid = typeof f1 === 'undefined' ? f2 : f1
                }
            })
        } else {
            state.requestPayload.current_page_email_from_muid = ''
        }
    },
    
    [types.REQUEST_PANELIST](state, payload) {
        state.requestPayload.panelist = payload
    },
    [types.UPDATE_ALL](state, payload) {
        state.update_all = payload
    },
    [types.ID_TO_UPDATE](state, payload) {
        state.ids_to_update.push(payload)
    },
    [types.UPDATE_OBJECTS](state, payload) {
        let index = state.update_objects.findIndex(e => e.muid === payload.muid)
        if (index === -1) {
            state.update_objects.push(payload)
        }
        state.ids_to_update.push(payload.muid)
    },
    [types.REMOVE_UPDATE_OBJ](state, payload) {
        state.update_objects = state.update_objects.filter(e => e.muid !== payload)
        state.ids_to_update = state.ids_to_update.filter(e => e !== payload)
    },
    [types.REMOVE_ALL_UPDATE_OBJECTS](state) {
        state.update_objects = new Array()
        state.ids_to_update = new Array()
        state.update_all = false
    },
    [types.REMOVE_ALL_UPDATE_OBJ](state) {
        state.update_objects = []
        state.ids_to_update = []
    },
    [types.UPDATE_STATUS_BY_MUID](state, payload) {
        let index = state.update_objects.findIndex(e => e.muid === payload.muid)
        if (index > -1) {
            state.update_objects[index].deleted = payload.deleted
        }
    },
    [types.UPDATE_FLAG_BY_MUID](state, payload) {
        let index = state.update_objects.findIndex(e => e.muid === payload.muid)
        if (index > -1) {
            state.update_objects[index].panelist_core = payload.panelist_core
        }
    },
    [types.UPDATE_POINTS_BY_MUID](state, payload) {
        let index = state.update_objects.findIndex(e => e.muid === payload.muid)
        if (index > -1) {
            state.update_objects[index].panelist_score = payload.panelist_score
        }
    },
    [types.UPDATE_MARK_BY_MUID](state, payload) {
        let index = state.update_objects.findIndex(e => e.muid === payload.muid)
        if (index > -1) {
            state.update_objects[index].email_read = payload.email_read
        }
    },
    [types.COMPETI_IDS](state, payload) {
        state.competi_id = payload
    },
    [types.PRODUCT_ID](state, payload) {
        state.product_id = payload
    },
    [types.REMOVE_ALL_UPDATE_OBJ](state) {
        state.update_objects = []
        state.ids_to_update = []
    },
}

export default mutations
